import axios from 'axios'
import { CRM_API_URL } from '@/constants/api'

function getList (filialId) {
  return axios.get(`${CRM_API_URL}/filials/review-actions`, { params: { filial_id: filialId } })
    .then(response => response.data.data)
}

function update (filialId, data) {
  return axios.put(`${CRM_API_URL}/filials/review-actions`, { data }, { params: { filial_id: filialId } })
    .then(response => response.data.data)
}

export default { getList, update }
